/* Tag.tsx */

import React from "react";
import { Keyword } from '../../../../dataTypes/keywordManagment/types';

interface TagProps {
  keyword: Keyword;
  onRemove: () => void;
}

const Tag: React.FC<TagProps> = ({ keyword, onRemove }) => {
  return (
    <div className="flex items-center bg-[#6632FF] text-white px-2 py rounded-full space-x-2 shadow-md hover:bg-[#4421AA]">
      <span className="text-sm font-medium">{keyword.word}</span>
      <button onClick={onRemove} className="focus:outline-none text-white hover:text-gray-300 text-lg font-bold">
        ×
      </button>
    </div>
  );
};

export default Tag;
